export const pushEvent = () => {
  (window.dataLayer = window.dataLayer || []).push({
    event: 'autoEvent',
    eventCategory: `insurance-payment`,
    eventAction: 'insurance-payment_error',
    eventLabel: '',
    eventName: `insurance-payment_error`,
  });
};

export default pushEvent;
